import React, { useEffect, useRef, useState } from "react";
import { TableListPage } from "Components/TableListPage/MyTable";
import { UnorderedListOutlined } from "@ant-design/icons";
import { Button, Form, Space } from "antd";
import { MyPagination } from "Components/MyPagination/MyPagination";
import { DrawerWrapper } from "Components/DrawerWrapper/DrawerWrapper";
import { CreateWorkForm } from "./components/CreateWorkForm/CreateWorkForm";
import { useDispatch, useSelector } from "react-redux";
import {
  createWorkThunk,
  getAllWorksThunk,
  selectWorks,
  updateWorkThunk,
} from "AppStore/Slices/WorksSlice/WorksSlice";
import { UpdateWorkForm } from "./components/UpdateWorkForm/UpdateWorkForm";

export const WorksTableWrapper = () => {
  const { total, currentPage, worksList, isLoading } = useSelector(selectWorks);
  const [checkedWorkToUpdate, setCheckedWorkToUpdate] = useState(null);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [formCreate] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const timeoutId = useRef();
  const handleCreate = async () => {
    try {
      const values = await formCreate.validateFields();
      dispatch(createWorkThunk({ ...values }));
      setOpen(false);
      formCreate.resetFields();
    } catch (err) {
      return err;
    }
  };
  const handleEdit = async () => {
    try {
      const values = await formEdit.validateFields();
      dispatch(updateWorkThunk({ ...values, id: checkedWorkToUpdate }));
      setOpen(false);
      setCheckedWorkToUpdate(null);
      formEdit.resetFields();
    } catch (err) {
      return err;
    }
  };
  const columns = [
    {
      title: "Код",
      dataIndex: "code",
    },
    {
      title: "Назва",
      dataIndex: "title",
    },
    {
      title: "Одиниці",
      dataIndex: "unit",
    },
    {
      title: "Дії",
      render: (_, record) => (
        <Space>
          <Button
            icon={<UnorderedListOutlined />}
            onClick={() => {
              setCheckedWorkToUpdate(record.id);
            }}
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    clearTimeout(timeoutId.current);
    if (searchValue) {
      timeoutId.current = setTimeout(() => {
        if (page === 1) {
          dispatch(getAllWorksThunk({ searchValue }));
        } else {
          dispatch(getAllWorksThunk({ page, searchValue }));
        }
      }, 500);
      return;
    } else {
      dispatch(getAllWorksThunk({ page }));
    }
  }, [page, searchValue]);
  return (
    <>
      <TableListPage
        isLoading={isLoading}
        mainTitle={"Всі доступні роботи для обліку"}
        data={worksList}
        columns={columns}
        openDrawer={setOpen}
        setSearch={setSearchValue}
        search={searchValue}
      />

      <DrawerWrapper
        title="Створення роботи"
        showCreateBtn={true}
        open={open}
        setOpen={() => setOpen(false)}
        form={formCreate}
      >
        <CreateWorkForm form={formCreate} onFinish={handleCreate} />
      </DrawerWrapper>
      <DrawerWrapper
        title="Редагування роботи"
        showEditBtn={true}
        setOpen={() => setCheckedWorkToUpdate(null)}
        open={Boolean(checkedWorkToUpdate)}
        form={formEdit}
      >
        <UpdateWorkForm
          form={formEdit}
          workId={checkedWorkToUpdate}
          onFinish={handleEdit}
        />
      </DrawerWrapper>

      <MyPagination
        totalItems={total}
        limit={10}
        isLoading={isLoading}
        currentPage={currentPage}
        changePage={setPage}
      />
    </>
  );
};
